import './styles.scss';
import l from '../../../../lang';
import CardTypeIcon from '../../../../assets/icons/card-type.svg?url';
import TransferTypeIcon from '../../../../assets/icons/transfer-type.svg?url';
import CashTypeIcon from '../../../../assets/icons/cash-type.svg?url';

interface AccreditationTimesCard {
  icon: string;
  title: string;
  time: string;
  description: string;
  styles?: React.CSSProperties;
}

function AccreditationTimes() {
  const cards = [
    {
      icon: CardTypeIcon,
      title: l('paymentMethod.accreditation.card.title'),
      time: `7 ${l('paymentMethod.accreditation.days')}`,
      description: l('paymentMethod.accreditation.card.description'),
    },
    {
      icon: TransferTypeIcon,
      title: l('paymentMethod.accreditation.transfers.title'),
      time: `3 ${l('paymentMethod.accreditation.days')}`,
      description: l('paymentMethod.accreditation.transfers.description'),
      styles: { position: 'relative', right: '4px', height: '42px' },
    },
    {
      icon: CashTypeIcon,
      title: l('paymentMethod.accreditation.cash.title'),
      time: `3 ${l('paymentMethod.accreditation.days')}`,
      description: l('paymentMethod.accreditation.cash.description'),
      styles: { position: 'relative', left: '8px' },
    },
  ] as AccreditationTimesCard[];

  return (
    <div className="accreditation-times">
      {cards.map(card => (
        <div key={card.title} className="accreditation-times__card">
          <div className="accreditation-times__card__icon">
            <img style={card.styles} src={card.icon} alt={card.title} />
          </div>
          <div className="accreditation-times__card__title">
            <span>{card.title}</span>
          </div>
          <div className="accreditation-times__card__time">{card.time}</div>
          <div className="accreditation-times__card__separator"></div>
          <div className="accreditation-times__card__description">{card.description}</div>
        </div>
      ))}
    </div>
  );
}

export default AccreditationTimes;
